"use strict";
(function (PivotLinkFormat) {
    /**
     * Display Pivot Links as links
     */
    PivotLinkFormat[PivotLinkFormat["links"] = 0] = "links";
    /**
     * Display Pivot Links as Tabs
     */
    PivotLinkFormat[PivotLinkFormat["tabs"] = 1] = "tabs";
})(exports.PivotLinkFormat || (exports.PivotLinkFormat = {}));
var PivotLinkFormat = exports.PivotLinkFormat;
(function (PivotLinkSize) {
    /**
     * Display Link using normal font size
     */
    PivotLinkSize[PivotLinkSize["normal"] = 0] = "normal";
    /**
     * Display links using large font size
     */
    PivotLinkSize[PivotLinkSize["large"] = 1] = "large";
})(exports.PivotLinkSize || (exports.PivotLinkSize = {}));
var PivotLinkSize = exports.PivotLinkSize;

//# sourceMappingURL=Pivot.Props.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./components/Pivot/Pivot.Props.js
 ** module id = 233
 ** module chunks = 0
 **/